<template>
  <v-card class="elevation-8 pt-10 pb-10 pl-5 pr-5" height="480px">
    <v-img height="90" contain src="@/assets/logo.png"> </v-img>
    <v-card-title class="font-weight-black justify-center">
      {{ form_title }}
    </v-card-title>
    <v-card-subtitle class="font-weight-black text-center mt-0">
      {{ form_subtitle }}
    </v-card-subtitle>

    <template v-if="is_checking">
      身份驗證中
      <v-progress-linear indeterminate color="primary"></v-progress-linear>
    </template>

    <template v-else>
      <v-card-subtitle v-if="is_auth" class="font-weight-black text-center mt-0"> 驗證通過，即將登入 </v-card-subtitle>
      <v-card-subtitle v-else class="font-weight-black text-center mt-0"> 驗證失敗，無法登入 </v-card-subtitle>
    </template>
  </v-card>
</template>
<script>
import { apiCheckLoginWithData } from '@/api/user.js'
import { apiGetContainers } from '@/api/optimize.js'

export default {
  name: 'UserImpersonate',
  components: {},
  data: function () {
    return {
      // 登入視窗標題
      form_title: '',

      // 登入視窗副標題
      form_subtitle: '',

      // 密碼的數值
      password: '',

      // 密碼輸入框的標題文字
      password_label_text: '',

      // 密碼的數值
      password_confirm: '',

      // 密碼輸入框的標題文字
      password_confirm_label_text: '',

      // 登入按鈕的文字
      form_action_btn_text: '',

      is_auth: false,

      show_password_confirm: false,
      show_password: false,
      password_type: 'password',
      confirm_password_type: 'password',

      is_checking: true,
    }
  },

  created: async function () {
    this.initPage()
    console.log(this.$route.query)

    let access_token = this.$route.query.access_token.replace(' ', '+')
    if (!access_token) {
      return
    }
    let that = this
    this.$store.commit('resetState')
    setTimeout(function () {
      that.verifyUser(access_token)
    }, 1000)
  },
  mounted: function () {},
  methods: {
    initPage: function () {
      this.form_title = 'Optimize99'
      this.form_subtitle = '代客操作'
      this.password = ''
      this.password_label_text = '密碼'
      this.password_confirm = ''
      this.password_confirm_label_text = '確認密碼'
      this.form_action_btn_text = '更新'
    },
    async verifyUser(access_token) {
      try {
        localStorage.setItem('authorization_token', access_token)
        let data = await apiCheckLoginWithData()
        console.log(data)
        this.is_checking = false
        this.is_auth = true
        this.afterLogin(data.data)
      } catch (error) {
        let message = '使用者Token驗證失敗，原因: '
        if (error.response) {
          message += error.response.data.msg
        } else {
          message += error
        }
        this.$root.vtoast.show({
          message: message,
        })
        this.is_checking = false
      }
    },
    async afterLogin(user_info) {
      console.log('after_login', user_info)
      let user_info_container = []
      if (user_info.container_user_enabled && user_info.container_user_enabled.container) {
        user_info.container_user_enabled.container.forEach((container) => {
          user_info_container.push(container.id)
        })
      }

      this.$root.vtoast.show({
        message: '登入成功！',
        color: 'primary',
      })

      // vuex 紀錄使用者資料
      const result = user_info
      this.$store.commit('login', result)

      // org對容器的mapper
      let account_organizations = result.organizations
      // console.log('account_organizations', account_organizations)
      // 取所有org對應的container
      let organize_container_mapper = {}

      for (let idx = 0; idx < account_organizations.length; idx++) {
        let account_organization = account_organizations[idx]
        // console.log('account_organization', account_organization)
        let containers = await apiGetContainers(account_organization.org_id)
          .then(function (resp) {
            let data = resp.data.data
            console.log('containers', data)
            return data
          })
          .catch(function (error) {
            console.log('取得容器失敗，原因: ' + error)
            // that.$root.vtoast.show({ message: "取得組織容器失敗，原因: " + (error.response ? error.response.data : error) })
            return []
          })
        if (!user_info.is_beta_user) {
          // 如果有找到，代表有限制過可看到的容器，沒有找到預設就是全開
          let is_container_user = false
          if (user_info.container_user_enabled) {
            is_container_user = user_info.container_user_enabled.enabled_status.find((enabled_status) => {
              return enabled_status.userAuthId.orgId === account_organization.org_id && enabled_status.enable
            })
          }
          console.log('is_container_user', is_container_user)
          if (is_container_user) {
            containers = containers.filter((container) => {
              return user_info_container.includes(container.id)
            })
          }
        }

        console.log('filter_container', containers)
        organize_container_mapper[account_organization.org_id] = {
          organization: account_organization,
          containers: containers,
        }
      }

      console.log('organize_container_mapper', organize_container_mapper)

      // 沒有組織的話進不去！
      if (Object.keys(organize_container_mapper).length === 0) {
        this.$root.vtoast.show({
          message: '您的帳號無所屬任何組織，請先加入組織',
        })
        return
      }

      this.$store.commit('update_organize_container_mapper', organize_container_mapper)

      console.log(organize_container_mapper)

      let to_org_id = ''
      if (result.default_value) {
        if (result.default_value.last_seen_org && organize_container_mapper[result.default_value.last_seen_org]) {
          to_org_id = result.default_value.last_seen_org
        } else {
          to_org_id = Object.keys(organize_container_mapper)[0]
        }
      }
      let to_container_id = ''
      let match_container = []
      if (result.default_value && result.default_value.last_seen_container_id) {
        match_container = organize_container_mapper[to_org_id].containers.filter(function (container) {
          return container.id === result.default_value.last_seen_container_id
        })

        if (match_container.length !== 0) {
          to_container_id = match_container[0].id
        } else {
          if (organize_container_mapper[to_org_id].containers[0]) {
            to_container_id = organize_container_mapper[to_org_id].containers[0].id
          }
        }
      } else {
        if (organize_container_mapper[to_org_id].containers[0]) {
          to_container_id = organize_container_mapper[to_org_id].containers[0].id
        }
      }

      this.$store.commit('select_organize', organize_container_mapper[to_org_id].organization)
      if (to_container_id) {
        this.$store.commit('selected_container', match_container[0])
      }

      if (to_container_id) {
        this.$router.push(`/${to_org_id}/${to_container_id}/home`)
      } else {
        this.$router.push(`/${to_org_id}/home`)
      }
    },
  },
}
</script>
<style></style>
